import itIsFreeOrTrialOrDeveloper from './itIsFreeOrTrialOrDeveloper';

const itShouldRenderReports = (selectedSubscription, reportsTenantEnabled) => {
  return (
    itIsFreeOrTrialOrDeveloper(selectedSubscription) || reportsTenantEnabled
  );
};
export default itShouldRenderReports;
